// extracted by mini-css-extract-plugin
module.exports = {"nav_box":"nav_box--10uPF","nav":"nav--2JjZw","item":"item--1g81I","icon":"icon--esV4v","active_icon":"active_icon--3_kHk","nav_text":"nav_text--3LGWD","active":"active--204vS"};